$(function () {
  $(".df-news__article__description, .df-main__articles__item__description").each(function () {
    const content = $(this)
      .html()
      .replace(/(<([^>]+)>)/gi, "")
      .slice(0, 70)
      .concat("...");
    $(this).html(content);
  });

  $(".df-news__article__description *, .df-article__content *").removeAttr("style class id");
});
